import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

export default function SettingsSkeleton() {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={3} sx={{ ml: 20, mr: 20, mt: 1, pb: 2 }}>
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rectangular" width={180} height={36} />
          <Skeleton variant="rectangular" width={160} height={36} />
        </Stack>
        <Box>
          <Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />
          <Skeleton variant="text" width={360} height={24} sx={{ mb: 4 }} />
          <Skeleton variant="rectangular" height={48} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={48} sx={{ mb: 2 }} />
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Skeleton variant="rectangular" width={120} height={40} />
            <Skeleton variant="rectangular" width={120} height={40} />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
